const InHouseCardsContent = [
    {
        heading: 'Swimming Pool',
        text: "Dive into relaxation at our newly renovated all-weather outdoor swimming pool. The main pool, with a depth of 7 feet, is perfect for adults, while a dedicated 2-feet pool ensures kids enjoy a safe splash. An in-built jacuzzi and an intricately carved waterfall merging into the children’s pool add a refreshing charm.",
        timings: ['Summer 9:00 am to 8:00 pm', 'Winter 10:00 am to 5:00 pm'],
    },
    {
        heading: 'Games Room',
        text: 'Make your vacation fun-filled at our Games Room. Equipped with billiards, table tennis, carrom, and a variety of board games, it promises endless recreation for families and friends. Perfect for guests of all ages who enjoy a little competition during their stay.'
    },
    {
        heading: 'Tiny Tots Corner',
        text: 'Traveling with children? We’ve got you covered. The Tiny Tots Corner is designed to keep our youngest guests entertained in a safe, joyful environment while parents enjoy their holiday with peace of mind.'
    },
    {
        heading: 'Dine by the Pool',
        text: 'Elevate your culinary journey with a private dining experience by the pool. Surrounded by the calming waters and starlit skies of Mount Abu, it’s the perfect setting for romantic dinners or memorable family gatherings.',
    },
    {
        heading: 'Personalized Room Décor',
        text: 'Make your stay even more special with customized room décor at your request. Whether it’s for a birthday, anniversary, or just to surprise a loved one, our team ensures every detail is just right.',
    },
    {
        heading: 'Barbecue by the Pool',
        text: 'Nothing beats the aroma of a live barbecue under the open skies. Relish sizzling flavors while enjoying the cool breeze of Mount Abu – an experience that turns an evening into a celebration.',
    },
    {
        heading: 'Musical Evenings at Risa',
        text: 'At Risa, our exclusive lounge, evenings come alive with carefully curated musical performances. Unwind with soulful melodies, fine drinks, and an ambiance that makes every night unforgettable.',
        speacial :'(Seasonal)'
    },
    {
        heading: 'Rajasthani Folk Music',
        text: 'Immerse yourself in the soulful folk music of Rajasthan. As the evening sets in, let the sensuous rhythms of live traditional performances in our lush lawns transport you into the cultural heart of Mount Abu.',
        speacial :'(Seasonal)'
    },
    {
        heading: 'Puppet Show',
        text: 'Experience the magic of Kathputli – Rajasthan’s legendary string puppet theatre. This timeless form of storytelling has entertained generations, and our exclusive evening puppet shows bring local tradition alive for guests of all ages.',
        speacial :'(Seasonal)'
    }
];

const ArounTheCityCardsContent = [
    {
        heading: 'Explore on wheels',
        text: 'Why not stay fit even when you are on your vacation? You can rent bicycles from our hotel and explore the best places in Mount Abu!'
    },
    {
        heading: 'Trek a while',
        text: "Mount Abu offers a number of trekking-hiking trails for nature lovers. Toad-Rock Trek, Bailey's Walk, Trevors Tank Trail, Plummy Trek, Craigs Trails are a few to name. Indulge in an array of adventure activities with your friends like Rock climbing, Zorbing, Ziplining, Rappelling, Spelunking, Flying Fox to name a few."
    },
    {
        heading: 'Nakki Lake',
        text: 'Just 1 kilometer away from Hotel Hilltone, Nakki Jheel is the first man-made lake in India with a depth of around 110 meters. Spend your evening boating, aqua zorbing and savoring mouth-watering food that Mount Abu’s streets are famous for.'
    },
    {
        heading: 'Guru Shikhar',
        text: 'Located at 16 Kilometers from Hotel Hilltone, Guru Shikhar, a peak at an altitude of 5,676 feet, is the highest peak in Rajasthan and one of the best places to visit in Mount Abu.'
    },
    {
        heading: 'Dilwara Temple',
        text: 'Located at 3 Kilometers from Hotel Hilltone, Dilwara Temple is one of the finest Jain temples known world over for its phenomenal design and radiant marble stone carvings.'
    },
    {
        heading: 'Brahma Kumari International Headquarters',
        text: "The World Head Quarters of Brahma Kumaris is located at 1.5 Kilometers from Hotel Hilltone. Peace Park, Shanti Van, Universal Peace Hall are few of the spiritual establishments of the Brahma Kumaris in Mount Abu."
    },
    {
        heading: 'Sunset point',
        text: 'Located at 3 Kilometers from Hotel Hilltone, the Sunset Point gives a scenic perspective of the setting sun. The beautiful slopes, quiet encompassing, and the charming atmosphere makes it one of the most loved spot for the travelers.'
    },
    {
        heading: 'Trevors Tank',
        text: 'Located at 3 Kilometers from Hotel Hilltone, the tank offers pleasant landscape and is a prominent excursion destination for voyagers.'
    },
    {
        heading: 'Achalgarh Fort & Achaleshwar Mahadev Temple',
        text: 'Located at 6 Kilometers from Hotel Hilltone, Achaleshwar Mahadev Temple is famous for its natural occurring shiva linga, and is one of the most oldest temples.'
    },
];

export { InHouseCardsContent, ArounTheCityCardsContent };